// src/composables/useScreenSize.js
import { ref, onMounted, onUnmounted, computed } from 'vue';

export function useScreenSize() {
  const screenWidth = ref(window.innerWidth);

  const updateScreenSize = () => {
    screenWidth.value = window.innerWidth;
  };

  onMounted(() => {
    window.addEventListener('resize', updateScreenSize);
  });

  onUnmounted(() => {
    window.removeEventListener('resize', updateScreenSize);
  });

  return {
    screenWidth,
    isLargeScreen: computed(() => screenWidth.value >= 1024),
    isMediumScreen: computed(() => screenWidth.value >= 768 && screenWidth.value < 1024),
    isSmallScreen: computed(() => screenWidth.value < 768),
    isXLScreen: computed(() => screenWidth.value >= 1280),
    
    // Breakpoint helpers
    isAboveLarge: computed(() => screenWidth.value > 1024),
    isBelowLarge: computed(() => screenWidth.value < 1024),
    isAboveMedium: computed(() => screenWidth.value > 768),
    isBelowMedium: computed(() => screenWidth.value < 768),
  };
}
